export const notePrivacyOptions: { label: string; value: string }[] = [
  { label: 'Private', value: 'private' },
  { label: 'Public', value: 'public' }
];
